import React, { Component } from 'react';
import PropTypes from 'prop-types';
// common components
import PageHeader from './../../common/PageHeader/PageHeader';
import Modal from './../../common/Modal/Modal';
import Pagination from './../../common/Pagination/Pagination';
// components
import SalesExecutiveList from './SalesExecutiveList/SalesExecutiveList';
import SalesExecutiveTable from './SalesExecutiveList/SalesExecutiveTable';
import ManageSalesExecutive from './ManageSalesExecutive/ManageSalesExecutive';
// css
import './SalesExecutive.scss';

class SalesExecutive extends Component {
	constructor(props) {
		super(props);
		this.state = {
			toggleView: true,
			salesexecutiveModal: false,
			title: '',
			salesexecutiveId: '',
			salesexecutiveDetails: {
				firstname: '',
				lastname: '',
				email: '',
				phone: '',
				country: '',
				city: ''
			},
			errorSalesExecutiveDetails: {
				firstname: true,
				lastname: true,
				email: true
			}
		}
		this.manageSalesExecutive = this.manageSalesExecutive.bind(this);
		this.confirmSalesExecutiveAction = this.confirmSalesExecutiveAction.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		const { } = this.state;
		const { salesexecutiveContext } = this.props;

		salesexecutiveContext.getSalesExecutiveList(1, 25);
	}

	componentWillUnMount() {
		this.props.salesexecutiveContext.clearSalesExecutiveList();
		this.props.commonContext.updatePagination();
		this.props.commonContext.updateLoaderMsg();
	}

	componentWillReceiveProps(nextProps) {
		const { title } = this.state;
		const { salesexecutiveDetails: { firstname, lastname, email, phone, country, city } } = nextProps.salesexecutiveContext;

		if (title === 'edit') {
			this.setState({
				salesexecutiveDetails: { firstname, lastname, email, phone, country, city },
				errorSalesExecutiveDetails: {
					firstname: !firstname || firstname === '',
					lastname: !lastname || lastname === '',
					email: !email || email === ''
				}
			});
		}
	}

	// pagination
	onChangePage = (curr_page, size) => {
		this.props.salesexecutiveContext.getSalesExecutiveList(curr_page, size);
	}

	// Modal (salesexecutive_module)

	// open Modal (salesexecutive_module)
	manageSalesExecutive = (value, title = null, salesexecutive_id = null) => {
		const { getSalesExecutiveDetails } = this.props.salesexecutiveContext;
		if (value) {
			if (title === 'edit') {
				getSalesExecutiveDetails(salesexecutive_id);
			} else {
				this.setState({
					salesexecutiveDetails: {
						firstname: '',
						lastname: '',
						email: '',
						phone: '',
						country: '',
						city: ''
					},
					errorSalesExecutiveDetails: {
						firstname: true,
						lastname: true,
						email: true
					}
				});
			}
		} else {
			this.setState({
				salesexecutiveDetails: {
					firstname: '', 
					lastname: '',
					email: '',
					phone: '',
					country: '',
					city: ''
				},
				errorSalesExecutiveDetails: {
					firstname: true,
					lastname: true,
					email: true
				}
			});
		}
		this.setState({
			salesexecutiveId: salesexecutive_id,
			salesexecutiveModal: value,
			title
		});
	}

	// modal onchange fields (salesexecutive_module)
	onChange = (e, val) => {
		this.setState({
			salesexecutiveDetails: {
				...this.state.salesexecutiveDetails,
				[e.target.name]: e.target.value
			},
			errorSalesExecutiveDetails: {
				...this.state.errorSalesExecutiveDetails,
				[e.target.name]: val
			}
		});
	}

	confirmSalesExecutiveAction = () => {
		const { title, salesexecutiveDetails, salesexecutiveId } = this.state;
		const { updateSalesExecutiveDetails, deleteSalesExecutive, addSalesExecutive } = this.props.salesexecutiveContext;

		if (title === 'edit') {
			updateSalesExecutiveDetails(salesexecutiveDetails, salesexecutiveId);
		} else if (title === 'add') {
			addSalesExecutive(salesexecutiveDetails);
		} else if (title === 'delete') {
			deleteSalesExecutive(salesexecutiveId);
		}
	}

	onToggle = () => {
		this.setState({
			...this.state,
			toggleView: !this.state.toggleView
		});
	}

	onDisable = (ers) => {
		const value = Object.keys(ers).some(val => ers[val] === true);
		return value;
	}


	render() {
		const { salesexecutiveList } = this.props.salesexecutiveContext;
		const { pagination } = this.props.commonContext;
		const { salesexecutiveModal, title, salesexecutiveDetails } = this.state;

		return (
			<div className='SalesExecutive'>
				<PageHeader
					title='Sales Executive List'
					btnText='Sales Executive'
					onAdd={() => this.manageSalesExecutive(true, 'add')}
					isToggle
					toggleValue={this.state.toggleView}
					onToggle={() => this.onToggle()}
				/> 
				{this.state.toggleView ? (
					<SalesExecutiveTable
                    	salesexecutiveList={salesexecutiveList}
						manageSalesExecutive={this.manageSalesExecutive}
					/>
				) : (
						<SalesExecutiveList
                        	salesexecutiveList={salesexecutiveList}
							manageSalesExecutive={this.manageSalesExecutive}
						/>
					)}

                   {pagination && pagination.totalElements > 0 &&
					<Pagination
						totalPage={pagination.totalPages}
						onChangePage={this.onChangePage}
						count={pagination.totalElements}
						first={pagination.first}
						last={pagination.last}
					/>
				} 
				{/* Add, Edit, and delete salesexecutive */}
				{salesexecutiveModal &&
					<Modal
						modalOpen={salesexecutiveModal}
						toggleModal={this.manageSalesExecutive}
						title={`${title} SalesExecutive`}
						disabled={title !== 'delete' && this.onDisable(this.state.errorSalesExecutiveDetails)}
						confirm={this.confirmSalesExecutiveAction}
					>
						<ManageSalesExecutive
							isEdit={title === 'edit'}
							onDelete={title === 'delete'}
							salesexecutiveDetails={salesexecutiveDetails}
							onChange={(e, val) => this.onChange(e, val)}
						/>
					</Modal>
				}
				{/* Add, Edit, and delete salesexecutive */}
			</div>
		);
	}
}


SalesExecutive.propTypes = {
	value: PropTypes.instanceOf(Object)
};

SalesExecutive.defaultProps = {
	value: {}
};

export default SalesExecutive;



// WEBPACK FOOTER //
// ./components/SalesExecutive/SalesExecutive.js